import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card lifecycle-card scroll-wrapper lot-block-wrapper"
}
const _hoisted_2 = { class: "card-title-block" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "lifecycle-block" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "checked"
}
const _hoisted_7 = { class: "lot-info" }
const _hoisted_8 = { class: "lot-info-item" }
const _hoisted_9 = { class: "lot-info-item-value" }
const _hoisted_10 = { class: "lot-info-item dimension" }
const _hoisted_11 = { class: "lot-info-item-value" }
const _hoisted_12 = { class: "lot-info-item stage" }
const _hoisted_13 = { class: "lot-info-item-value" }
const _hoisted_14 = { class: "lot-info-item" }
const _hoisted_15 = { class: "lot-info-item-value" }
const _hoisted_16 = { class: "lot-info-item" }
const _hoisted_17 = { class: "lot-info-item-value" }
const _hoisted_18 = { class: "lot-info-item buyer" }
const _hoisted_19 = {
  key: 0,
  class: "lot-info-item-value"
}
const _hoisted_20 = {
  key: 1,
  class: "lot-info-item-value"
}
const _hoisted_21 = {
  key: 2,
  class: "lot-info-item-value"
}
const _hoisted_22 = { class: "lot-info-item" }
const _hoisted_23 = { class: "buyers" }
const _hoisted_24 = {
  key: 0,
  class: "lot-info-item-value"
}
const _hoisted_25 = {
  key: 1,
  class: "lot-info-item-value"
}
const _hoisted_26 = { class: "lot-info-item" }
const _hoisted_27 = { class: "lot-info-item-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.lot)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-title" }, "Lot Lifecycle", -1)),
          _createElementVNode("div", _hoisted_3, "Step " + _toDisplayString($props.lot.status === $setup.LotStatus.OPTION ? $setup.lotStatusList.length : $setup.currentStatusIndex + 1) + " of " + _toDisplayString($setup.lotStatusList.length) + ": " + _toDisplayString($setup.getStepStatus), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lotStatusList, (status, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["status-item", $setup.getStatusItemClass(index, status)])
            }, [
              (index >= $setup.currentStatusIndex)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(status === $setup.LotStatus.EOI ? $setup.getPreContractOrHoldStatus : status), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6))
            ], 2))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "lot-info-item-title" }, "Block Size", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString($setup.formatPrice($props.lot.size, false)) + " m", 1),
              _cache[2] || (_cache[2] = _createElementVNode("sup", null, "2", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "lot-info-item-title" }, "Dimensions", -1)),
            _createElementVNode("div", _hoisted_11, _toDisplayString($props.lot.blockWidth && $props.lot.blockDepth ? `${$setup.formatPrice($props.lot.blockWidth, false)}m x ${$setup.formatPrice($props.lot.blockDepth, false)}m` : "Irregular"), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "lot-info-item-title" }, "Stage", -1)),
            _createElementVNode("div", _hoisted_13, _toDisplayString($props.lot.stageId.title), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "lot-info-item-title" }, "Release Date", -1)),
            _createElementVNode("div", _hoisted_15, _toDisplayString($props.lot.releaseDate ? $setup.formatDate($props.lot.releaseDate, "DD MMM YYYY") : '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "lot-info-item-title" }, "Price", -1)),
            _createElementVNode("div", _hoisted_17, _toDisplayString($setup.formatPrice($props.lot.price)), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "lot-info-item-title" }, "Initial Deposit", -1)),
            ($props.lot.status === $setup.LotStatus.OFFLINE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.formatStripePrice($props.lot.offlineSale.offlineDeposit)), 1))
              : ($props.lot.buyerId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.paymentRequest ? $setup.formatStripePrice($setup.depositFromInvoice) : "-"), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, "-"))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "lot-info-item-title" }, "Buyer", -1)),
            _createElementVNode("div", _hoisted_23, [
              ($props.lot.status !== $setup.LotStatus.OFFLINE)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["lot-info-item-value", { highlighted: $props.lot.eoiId?.buyersData?.firstBuyer }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.moveToTheContactDetailsPage()))
                    }, _toDisplayString($props.lot.eoiId ? $setup.getFirstLastName($props.lot.eoiId.buyersData.firstBuyer) : "-"), 3),
                    ($props.lot.eoiId && $props.lot.eoiId.buyersData.secondBuyer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($setup.getFirstLastName($props.lot.eoiId.buyersData.secondBuyer)), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($props.lot?.offlineSale?.offlineBuyerData?.fullName || "-"), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "lot-info-item-title" }, "Registration Date", -1)),
            _createElementVNode("div", _hoisted_27, _toDisplayString($props.lot.registrationDate ? $setup.formatDate($props.lot.registrationDate, "MMM YYYY") : '-'), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}